/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-03-11 14:30:38
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-03-27 18:21:57
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/api/user.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'
import { encryptedData } from '@/utils/encrypt'
import { loginRSA } from '@/config'

export async function login(data) {
  if (loginRSA) {
    data = await encryptedData(data)
  }
  return request({
    url: '/iam/login',
    method: 'post',
    data,
  })
}

export async function socialLogin(data) {
  if (loginRSA) {
    data = await encryptedData(data)
  }
  return request({
    url: '/auth/socialLogin',
    method: 'post',
    data,
  })
}

export function getUserInfo() {
  return request({
    url: '/iam/getUserInfo?sysCode=mehz',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/iam/logout',
    method: 'get',
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data,
  })
}

/**
 * @description: 获取租户基本信息
 * @return {*}
 */
export function getCustomInfoApi(params) {
  return request({
    url: '/iam/tenant/getCustomInfo',
    method: 'get',
    params,
  })
}

/**
 * @description: 获取短信验证码
 * @return {*}
 */
export function getValidCodeMsg(params) {
  return request({
    url: '/iam/myself/user/getPhoneVerifyCode',
    method: 'get',
    params,
  })
}

/**
 * @description: 查询当前用户详情
 * @return {*}
 */
export function getUserDetail() {
  return request({
    url: `/iam/admin/user/detail`,
    method: 'get',
  })
}

/**
 * @description: 用户自己修改个人信息
 * @return {*}
 */
export function upDateUserInfo(data) {
  return request({
    url: '/iam/myself/user/updateProfile',
    method: 'put',
    data,
  })
}

/**
 * @description: 修改个人密码
 * @param {*} data
 * @return {*}
 */
export function upDateUserPassword(data) {
  return request({
    url: '/iam/myself/user/updatePwd',
    method: 'put',
    data,
  })
}
/**
 * @description: 用户重置密码
 * @param {*} data
 * @return {*}
 */
export function resetPassword(data) {
  return request({
    url: '/iam/myself/user/resetPassword',
    method: 'post',
    data,
  })
}

/**
 * @description: 生成绑定微信二维码
 * @return {*}
 */
export function generateBindUrl(data) {
  return request({
    url: '/iam/wechat/user/generateBindUrl',
    method: 'post',
    data,
  })
}

/**
 * @description: 生成微信登录二维码
 * @return {*}
 */
export function generateLoginUrl(data) {
  return request({
    url: `/iam/wechat/user/generateLoginUrl?tenantKey=${data.tenantKey}`,
    method: 'post',
    data,
  })
}

/**
 * @description: 轮询二维码获取微信登录状态
 * @return {*}
 */
export function wxLogin(params) {
  return request({
    url: '/iam/wx/login',
    method: 'get',
    params,
  })
}

/**
 * @description: 微信绑定解绑
 * @return {*}
 */
export function unbindWeChart() {
  return request({
    url: '/iam/wechat/user/unbind',
    method: 'get',
  })
}

/**
 * @description: 查询绑定微信的状态
 * @return {*}
 */
export function bindChartStatus() {
  return request({
    url: '/iam/wechat/user/bindStatus',
    method: 'get',
  })
}

/**
 * @description: 查询iam 用户绑定企业
 * @return {*}
 */
export function getUserEnterPriseAccount(params) {
  return request({
    url: '/user/admin/user/getUserAccount',
    method: 'get',
    params,
  })
}

/**
 * @description: 查询iam
 * @return {*}
 */
export function getUserByPhone(params) {
  return request({
    url: '/user/admin/user/getUserByPhone',
    method: 'get',
    params,
  })
}

/**
 * @description: 查询待审核的实名用户列表
 * @return {*}
 */
export function getRealNameAuditList(data) {
  return request({
    url: '/user/admin/user/auditList',
    method: 'POST',
    data,
  })
}

/**
 * @description: 待审核的实名用户审核
 * @return {*}
 */
export function RealNameAudit(data) {
  return request({
    url: '/user/admin/user/audit',
    method: 'POST',
    data,
  })
}
